import { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import { useQuery } from "react-query";
import styled from "styled-components";
import { getOneDivisionItem, getOnePolicyItem } from "../api/api";
import { IInnerDivision } from "../types/inner_page";
import { Comment, TailSpin } from "react-loader-spinner";
import { useTranslation } from "react-i18next";
import InnerPageLayout from "../Components/Layout/InnerPageLayout";
import { Link, useParams } from "react-router-dom";
import Caac from "../Components/Chart/caac.js";
import {
  Card,
  Col,
  Row,
  Tab,
  Tabs,
  Modal,
  Container,
  Button,
} from "react-bootstrap";
import axios from "axios";
import DivisionNewsShowcase from "../Components/DivisionNewsShowcase";
import DivisionLibraryWidget from "../Components/homepageComponents/DivisionLibraryWidget";
import SingleGalleryW from "./gallery/SingleGalleryW";
import PdfEmbed from "./PdfEmbed";
import { HRDivision } from "../Components/HR/HRDivision";
import DepartmentsOfDivision from "./Departments/DepartmentsOfDivision";
import DepartmentsOfDivisionAndFiles from "./Departments/DepartmentsOfDivisionAndFiles";
import LibrariesFilesOfDivision from "./Departments/LibrariesFilesOfDivision";

const DivisionsPage = () => {
  let { id } = useParams();

  const { i18n, t } = useTranslation();

  const { isLoading, error, data, refetch }: any = useQuery(
    `innerDivisionData-${id}`,
    () => getOneDivisionItem({ id: id || "1", language: i18n.language })
  );

  const {
    isLoading: isLoading2,
    error: error2,
    data: data2,
    refetch: refetch2,
  }: any = useQuery(`innerPolicyData-${id}`, () =>
    getOnePolicyItem({ id: id || "1", language: i18n.language })
  );

  const [orgData, setOrgData] = useState<any | null>(null);
  const [departments, setDepartments] = useState<any | null>(null);

  useEffect(() => {
    if (data && data2) {
      let pageItem: IInnerDivision = data["data"];
      // console.log("pageItem",pageItem.attributes);
      setDepartments(pageItem.attributes?.departments);
      const url = `https://eportal-org-chart.rafedsa.com/structure/per_department?email=${pageItem.attributes.managerEmail}&lang=${i18n.language}`;

      const fetchData = async () => {
        try {
          const response = await axios.get<any>(url);
          setOrgData(response.data);
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };

      fetchData();
    }
  }, [data, data2, i18n.language, refetch, refetch2]);

  useEffect(() => {
    refetch();
  }, [i18n.language, refetch]);

  useEffect(() => {
    refetch2();
  }, [i18n.language, refetch2]);

  if (isLoading || isLoading2)
    return (
      <InnerPageLayout>
        <LoaderContainer>
          <TailSpin color="#ffffff" height={70} width={70} />
        </LoaderContainer>
      </InnerPageLayout>
    );

  if (error || error2)
    return (
      <InnerPageLayout>
        <div></div>
      </InnerPageLayout>
    );

  let pageItem: IInnerDivision = data["data"];
  let IsHrDivision = pageItem.id === 3; // HR ID

  if (i18n.language === "en") {
    const localizations = data["data"]["attributes"]["localizations"]["data"];
    const enLocalization = localizations.find(
      (loc: any) => loc["attributes"]["locale"] === "en"
    );

    if (enLocalization) {
      pageItem = enLocalization;
    }
  }

  return (
    <InnerPageLayout>
      <>
        <Row>
          <Col md={pageItem.attributes.category ? 8 : 12}>
            <Card
              id={i18n.language === "en" ? "custom-card-en" : "custom-card-ar"}
              className="custom-card right mb-4"
            >
              <Card.Header className="custom-card-header">
                {pageItem.attributes.title}
              </Card.Header>
              <Card.Body className="d-flex p-0">
                <div className="text-section p-4">
                  <ReactMarkdown className="description">
                    {pageItem.attributes.content}
                  </ReactMarkdown>
                </div>
              </Card.Body>
            </Card>
          </Col>

          {(pageItem.id === 6 || pageItem.id === 12) && (
            <Col
              md={4}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Link to="/projects/2">
                <img
                  src="/static/img/tarabout_logo.png"
                  alt={i18n.t("tarabut")}
                  style={{ maxWidth: "100%", height: "auto" }}
                />
              </Link>
            </Col>
          )}

          {pageItem.attributes.category &&
            pageItem.id !== 6 &&
            pageItem.id !== 12 && (
              <Col md={4}>
                <SingleGalleryW id={pageItem.attributes.category} />
              </Col>
            )}
        </Row>

        <DivisionNewsShowcase limit={9} subCategory={pageItem.id.toString()} />

        {/* {!IsHrDivision && (
          <Card className="mb-4">
            <Card.Header>{t("menu.policies_and_procedures")}</Card.Header>
            <Card.Body>
              <Tabs defaultActiveKey="0" id="faq-tabs" className="mb-3 tabs">
                {data2["data"].map((pageItem: any, index: number) => (
                  <Tab
                    eventKey={index}
                    title={pageItem.attributes.Title}
                    key={index}
                  >
                    <PdfEmbed
                      embedURL={`${process.env.REACT_APP_CMS}${
                        pageItem.attributes.file.data.attributes.url ?? ""
                      }`}
                    />
                  </Tab>
                ))}
              </Tabs>
            </Card.Body>
          </Card>
        )} */}

        {/* <DepartmentsOfDivision departments={departments} /> */}

         <LibrariesFilesOfDivision departmentid={pageItem.id} />
         
        {/* {!IsHrDivision && (
          <DivisionLibraryWidget subCategory={pageItem.id.toString()} />
        )} */}

        {!IsHrDivision && (
          <Card className="mb-4">
            <Card.Header>{i18n.t("organization_structure")}</Card.Header>
            <Card.Body>
              <div dir="ltr">{orgData && <Caac ds={orgData} />}</div>
            </Card.Body>
          </Card>
        )}

        {IsHrDivision && <HRDivision />}
      </>
    </InnerPageLayout>
  );
};

const LoaderContainer = styled.div`
  min-height: 60vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default DivisionsPage;
